import type { IconData } from '@stacksjs/iconify-core'

export const smileysAngry: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m4-5a4 4 0 0 0-8 0zM4 6h2a2 2 0 0 0-2-2zm6 0h2V4a2 2 0 0 0-2 2\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default smileysAngry
